import { Raycaster, Vector2 } from 'three';

// mouse.js handles logic for THREE.Raycaster to make the beacons clickable 
// TODO could be renamed to something like BeaconRaycaster
export default class Mouse {
  constructor(state, scene, camera, container, beacons) {
    this.state = state;
    this.scene = scene;
    this.camera = camera;
    this.container = container;
    this.beacons = beacons;

    this.raycaster = new Raycaster();
    this.mouse = new Vector2();

    this.onMouseMove = this.onMouseMove.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onMouseMove(event) {
    this.mouse.x = (event.clientX / this.container.clientWidth) * 2 - 1;
    this.mouse.y = -(event.clientY / this.container.clientHeight) * 2 + 1;

    this.raycast();
  }

  onClick() {
    if (this.targetBeacon) {
      this.beacons.onBeaconClick(this.targetBeacon);
      this.beacons.onBeaconExit(this.targetBeacon);
      this.targetBeacon = null;
    }
  }

  raycast() {
    this.raycaster.setFromCamera(this.mouse, this.camera);

    const intersects = this.raycaster.intersectObjects(this.scene.children, true);

    let beaconFound = false;

    intersects.forEach((intersect) => {
      
      // each beacon is named 'beacon-[view.name]'
      const prefix = 'beacons-';
      if (intersect.object.name.startsWith(prefix)) {
        this.targetBeacon = intersect.object.name.substring(prefix.length);
        beaconFound = true;
      }
    });

    if (beaconFound) this.beacons.onBeaconEnter(this.targetBeacon);
    else if (this.targetBeacon) {
      this.beacons.onBeaconExit(this.targetBeacon);
      this.targetBeacon = null;
    }
  }


  setActive(value) {
    if (value) {
      document.addEventListener('mousemove', this.onMouseMove);
      document.addEventListener('click', this.onClick);
    } else {
      document.removeEventListener('mousemove', this.onMouseMove);
      document.removeEventListener('click', this.onClick);
    }
  }
}
